export const MarketingListStatus = Object.freeze({
  PENDING: 'pending',
  IMPORTING: 'importing',
  SYNCING: 'syncing',
  FAILURE: 'failure',
  SUCCESS: 'success',
});

export const MarketingListType = Object.freeze({
  STANDARD: 'standard',
  SYSTEM: 'system',
});
